import { StatusTypes } from "../../types/common";

export const formatStatus = (status: number) => {
  return status === 0 ? StatusTypes.Active : StatusTypes.Blocked;
};

export const compareComplexData = <T extends {}>(obj1: T, obj2: T) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};
